/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Faq_3_AInputs */

const en_b2b_faq_3_a = /** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. All orders, customer details, and high-intent leads generated by the AI Concierge can be exported instantly via CSV for import into Salesforce, HubSpot, or your CRM of choice.`)
};

const es_b2b_faq_3_a = /** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Todos los pedidos, detalles de clientes y leads generados por el Conserje IA se pueden exportar instantáneamente vía CSV para importarlos en tu CRM de elección.`)
};

const fr_b2b_faq_3_a = /** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Toutes les commandes, les détails des clients et les prospects à forte intention générés par le Concierge IA peuvent être exportés instantanément via CSV pour être importés dans Salesforce, HubSpot ou votre CRM de choix.`)
};

const de_b2b_faq_3_a = /** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Alle Bestellungen, Kundendaten und High-Intent-Leads können sofort als CSV exportiert werden.`)
};

const id_b2b_faq_3_a = /** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya. Semua pesanan, detail pelanggan, dan prospek berniat tinggi yang dihasilkan oleh Pramutamu AI dapat diekspor seketika melalui CSV untuk diimpor ke Salesforce, HubSpot, atau CRM pilihan Anda.`)
};

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const ja_b2b_faq_3_a = en_b2b_faq_3_a;

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const zh_b2b_faq_3_a = en_b2b_faq_3_a;

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const ar_b2b_faq_3_a = en_b2b_faq_3_a;

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const it_b2b_faq_3_a = en_b2b_faq_3_a;

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const ru_b2b_faq_3_a = en_b2b_faq_3_a;

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const pt_b2b_faq_3_a = en_b2b_faq_3_a;

/** @type {(inputs: B2b_Faq_3_AInputs) => LocalizedString} */
const ko_b2b_faq_3_a = en_b2b_faq_3_a;

/**
* | output |
* | --- |
* | "Yes. All orders, customer details, and high-intent leads generated by the AI Concierge can be exported instantly via CSV for import into Salesforce, HubSpot,..." |
*
* @param {B2b_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_faq_3_a = /** @type {((inputs?: B2b_Faq_3_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Faq_3_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_faq_3_a(inputs)
	if (locale === "es") return es_b2b_faq_3_a(inputs)
	if (locale === "fr") return fr_b2b_faq_3_a(inputs)
	if (locale === "de") return de_b2b_faq_3_a(inputs)
	if (locale === "ja") return ja_b2b_faq_3_a(inputs)
	if (locale === "zh") return zh_b2b_faq_3_a(inputs)
	if (locale === "ar") return ar_b2b_faq_3_a(inputs)
	if (locale === "id") return id_b2b_faq_3_a(inputs)
	if (locale === "it") return it_b2b_faq_3_a(inputs)
	if (locale === "ru") return ru_b2b_faq_3_a(inputs)
	if (locale === "pt") return pt_b2b_faq_3_a(inputs)
	return ko_b2b_faq_3_a(inputs)
});